import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Spinner, TemplateSalesTotalServiceCharge } from 'telia-front-react';

import ProductCurrentBalanceModalStore from '../../stores/ProductCurrentBalanceModalStore';
import WarningNotice from '../invoice/notices/WarningNotice';
import ClosableModal from '../common/ClosableModal';

interface IInvoiceDetailsProps {
  productCurrentBalanceModalStore?: ProductCurrentBalanceModalStore;
}

@inject('productCurrentBalanceModalStore')
@observer
export default class ProductCurrentBalanceModal extends React.Component<IInvoiceDetailsProps> {
  public render(): JSX.Element {
    return (
      <ClosableModal
        gaPage={this.props.productCurrentBalanceModalStore.gaPageLabel}
        gaGroup="Product current balance"
        errorNoticeTranslationKey="shared.product-current-balance-modal.failed-to-render"
      >
        {this.content()}
      </ClosableModal>
    );
  }

  private content() {
    const modalProps = this.props.productCurrentBalanceModalStore.modalProps;

    if (modalProps.isInitialLoading) {
      return <Spinner />;
    }

    if (modalProps.isFinishedWithError) {
      return <WarningNotice translationKey="shared.product-current-balance-modal.failed-to-render" />;
    }

    return (
      <>
        <TemplateSalesTotalServiceCharge {...modalProps.payload} />
      </>
    );
  }
}
